<template>
  <div>
    <el-time-picker is-range v-model="timeData" step="00:15:00" format="HH:mm" value-format="HH:mm" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" :use-24-hour="true" :picker-options="{
      selectableRange: '00:00-23:59', 
      
      }"></el-time-picker>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      timeData: [],
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
::v-deep .el-input__icon {
  display: none;
}
::v-deep .el-range-editor.el-input__inner {
  width: 140px;
}
</style>
<style lang="scss">
.timePicker {
  width: 220px !important;
}
</style>